import * as React from 'react';

import {SaveButton} from 'shells/button/save-button/save-button';
import {colors} from 'shells/colors/colors';
import {NotSyncedIcon} from 'shells/icon';
import {SyncRegularIcon} from 'shells/icon/svg/sync-regular-icon';
import {Stack} from 'shells/layout/stack/stack';
import {PopoverInfo} from 'shells/popover-info/popover-info';
import {Body} from 'shells/typography/body';

import type {ExternalService, ActivitySyncMode, ExternalServiceType} from 'nutshell-graphql-types';

import {getCalendarServiceName} from '../helpers';

import {getExternalServiceTypeName} from './helpers';

type Props = {
    isConnectedToExternalCalendar: boolean;
    handleUpdateActivity: () => void;
    isSyncing: boolean;
    calendarSyncExternalService: ExternalService | null | undefined;
    isScheduler: boolean;
    syncMode: ActivitySyncMode | null | undefined;
    serviceType: ExternalServiceType | null | undefined;
};

export function SyncStatusSection(props: Props) {
    if (props.syncMode === 'NEVER') {
        return (
            <div className='flex gap-4 align-center'>
                {/* @ts-expect-error */}
                <NotSyncedIcon size={13} wrapWithDiv={false} color={colors.greyLt} />
                <Body size='small' color={props.isScheduler ? 'error' : 'light'}>
                    Not synced with your calendar
                </Body>
                <PopoverInfo
                    info={`This activity will not sync to an external calendar because it was created from a completed ${getExternalServiceTypeName(
                        props.serviceType
                    )}.`}
                    size={14}
                    noIconPadding={true}
                />
            </div>
        );
    }

    if (props.isConnectedToExternalCalendar) {
        return (
            <Stack isHorizontal={true} spacing={4} alignItems='center'>
                <SyncRegularIcon size={13} wrapWithDiv={false} />
                <Body size='small' color='light'>
                    Synced with {getCalendarServiceName(props.calendarSyncExternalService)} calendar
                </Body>
            </Stack>
        );
    }

    return (
        <div className='flex gap-4 align-center'>
            <NotSyncedIcon
                size={13}
                wrapWithDiv={false}
                // @ts-expect-error
                color={props.isScheduler ? colors.error : colors.greyLt}
            />
            <Body size='small' color={props.isScheduler ? 'error' : 'light'}>
                Not synced with your calendar
            </Body>
            <SaveButton
                // @ts-expect-error
                onClick={props.handleUpdateActivity}
                isSaving={props.isSyncing}
                size='small'
                buttonText='Sync now'
                savingText='Syncing...'
                successText='Synced!'
                variant='text-primary'
                noPadding={true}
            />
        </div>
    );
}
